/// <amd-module name="SuiteCommerce.StockNotifications.Item.Option.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.StockNotifications.Item.Option.Model", ["require", "exports", "Backbone", "SuiteCommerce.StockNotifications.Item.Option.Value.Collection"], function (require, exports, Backbone_1, Item_Option_Value_Collection_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ItemOptionModel = void 0;
    var ItemOptionModel = /** @class */ (function (_super) {
        __extends(ItemOptionModel, _super);
        function ItemOptionModel(options) {
            var _this = _super.call(this, options) || this;
            _this.parseData();
            return _this;
        }
        Object.defineProperty(ItemOptionModel.prototype, "itemOptionId", {
            get: function () {
                return this.get('itemOptionId');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemOptionModel.prototype, "cartOptionId", {
            get: function () {
                return this.get('cartOptionId');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemOptionModel.prototype, "label", {
            get: function () {
                return this.get('label');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemOptionModel.prototype, "type", {
            get: function () {
                return this.get('type');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemOptionModel.prototype, "value", {
            get: function () {
                return this.get('value');
            },
            set: function (valueModel) {
                var value = null;
                var internalId;
                var label;
                if (valueModel) {
                    internalId = valueModel.internalId;
                    label = valueModel.label;
                    if (internalId || label) {
                        value = {
                            internalid: internalId ? internalId + '' : label,
                            label: label || internalId + ''
                        };
                    }
                }
                this.setValueModel(valueModel);
                this.set('value', value);
            },
            enumerable: false,
            configurable: true
        });
        ItemOptionModel.prototype.getValues = function () {
            return this.get('values');
        };
        Object.defineProperty(ItemOptionModel.prototype, "colors", {
            get: function () {
                return this.get('colors');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemOptionModel.prototype, "templateSelector", {
            get: function () {
                return this.get('templateSelector');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemOptionModel.prototype, "isTypeTextArea", {
            get: function () {
                return this.type === 'textarea';
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemOptionModel.prototype, "isTypeEmail", {
            get: function () {
                return this.type === 'email';
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemOptionModel.prototype, "isTypeText", {
            get: function () {
                return this.type === 'text';
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemOptionModel.prototype, "isTypeCheckbox", {
            get: function () {
                return this.type === 'checkbox';
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemOptionModel.prototype, "isTypeDate", {
            get: function () {
                return this.type === 'date';
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemOptionModel.prototype, "isTypeSelect", {
            get: function () {
                return this.type === 'select';
            },
            enumerable: false,
            configurable: true
        });
        ItemOptionModel.prototype.parseData = function () {
            this.parseIds();
            this.parseValues();
        };
        ItemOptionModel.prototype.parseIds = function () {
            var internalId = this.get('internalid');
            var cartOptionId = this.get('cartOptionId');
            var sourceFrom = this.get('sourcefrom');
            var itemOptionId = this.get('itemOptionId');
            if (!cartOptionId && internalId) {
                this.set('cartOptionId', internalId.toLowerCase());
            }
            if (!itemOptionId && sourceFrom) {
                this.set('itemOptionId', sourceFrom.toLowerCase());
            }
        };
        ItemOptionModel.prototype.parseValues = function () {
            var values = this.get('values');
            var collection = new Item_Option_Value_Collection_1.ItemOptionValueCollection(values);
            this.set('values', collection);
        };
        ItemOptionModel.prototype.setValueModel = function (valueModel) {
            this.valueModel = valueModel;
        };
        ItemOptionModel.prototype.getValueModel = function () {
            return this.valueModel;
        };
        ItemOptionModel.prototype.clearValue = function () {
            this.setValueModel(null);
            this.value = null;
        };
        Object.defineProperty(ItemOptionModel.prototype, "isSingleValue", {
            get: function () {
                var values = this.values();
                return values && values.length === 1;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemOptionModel.prototype, "isMatrixDimension", {
            get: function () {
                return this.get('ismatrixdimension');
            },
            enumerable: false,
            configurable: true
        });
        return ItemOptionModel;
    }(Backbone_1.Model));
    exports.ItemOptionModel = ItemOptionModel;
});
